<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :actions="false"
              @action="masterAction"
              :parentData="parentData"
    >
    </g-master>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['id_training'],
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        master: {
          endpoint: 'personas_aprobadas',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            actions: {
              actions: [
                {
                  name: 'descargarCertificado',
                  text: 'Descargar Certificado',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'file-pdf', style: 'color: red'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            columns: [
              {title: 'Asistente', dataIndex: 'asistente', sorter: true},
              {title: 'Nota Promedio', dataIndex: 'nota_promedio', sorter: true},
              {title: 'Asistencia Promedio', dataIndex: 'asistencia_promedio', sorter: true}
            ]
          }
        },
        loadingBtns: {}
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'descargarCertificado':
            this.downloadFilePDFOnlyOne(action.record)
            break
        }
      },
      downloadFilePDFOnlyOne (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)
        this.httpClient.getInstance().post('certificado_capacitacion/download', {
          params: {
            cc_participante: record.cc_participante,
            training_id: record.training_id
          }
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
          Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
          this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      }
    },
    computed: {
      parentData () {
        return {
          id_training: this.id_training
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/PersonasAprobadas.vue